import type { ICustomControlRequestAddEditProps } from '../pages/customControls/interfaces/';
import { translateKey } from '../../translate';
import { InputTextArea } from './common';
import { FormLabel } from './forms/FormLabel';
import { FormSection } from './forms/formSection/FormSection';
import { HorizontalFormGroup } from './forms/HorizontalFormGroup';
import { InputContainer } from './forms/InputContainer';

export function ContactWithRequesterOptionsAddEdit(props: ICustomControlRequestAddEditProps) {
    return (
        <FormSection
            isBorderLess
            title={translateKey('request.contactWithRequesterOptionsHeader')}
        >
            <HorizontalFormGroup hasErrors={props.errors.has('customControlData.contactWithRequesterOptions')}>
                <FormLabel>{translateKey('request.contactWithRequesterOptionsLabel')}</FormLabel>
                <InputContainer>
                    <InputTextArea
                        error={props.errors.get('customControlData.contactWithRequesterOptions')}
                        onChange={async (value) =>
                            await props.handleChangeCustomControl({ contactWithRequesterOptions: value })
                        }
                        onDoValidate={async () => await props.validateOneCustomControl('contactWithRequesterOptions')}
                        placeholder={translateKey('request.contactWithRequesterOptionsPlaceholder')}
                        value={props.request.customControlData.contactWithRequesterOptions}
                    />
                </InputContainer>
            </HorizontalFormGroup>
        </FormSection>
    );
}
